import { ExternalLink, ShieldCheck, Send } from "lucide-react";

/**
 * Dashboard top-strip with quick-launch pills for the external SelleCheck systems.
 * These intentionally open in new tabs (separate PCI-scoped sessions).
 */
export default function ExternalLaunchers() {
  return (
    <div className="flex flex-wrap items-center justify-end gap-3" data-testid="dashboard-launchers">
      <a
        href="https://SelleCheck.transactiongateway.com"
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex items-center gap-2 pl-3 pr-4 h-10 rounded-full border border-[#00D533]/40 bg-[#00D533]/5 hover:bg-[#00D533]/15 transition-colors"
        data-testid="launcher-gateway"
      >
        <span className="w-7 h-7 rounded-full bg-[#00D533] text-black flex items-center justify-center">
          <ShieldCheck className="w-4 h-4" strokeWidth={2.5} />
        </span>
        <span className="text-sm font-semibold text-slate-900 leading-none">SelleCheck Gateway</span>
        <span className="text-[10px] uppercase tracking-wider text-slate-500 font-mono hidden sm:inline">transactiongateway.com</span>
        <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-slate-700" />
      </a>
      <a
        href="https://SelleSend.com"
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex items-center gap-2 pl-3 pr-4 h-10 rounded-full border border-[#3B82F6]/40 bg-[#3B82F6]/5 hover:bg-[#3B82F6]/15 transition-colors"
        data-testid="launcher-sellesend"
      >
        <span className="w-7 h-7 rounded-full bg-[#3B82F6] text-white flex items-center justify-center">
          <Send className="w-4 h-4" strokeWidth={2.5} />
        </span>
        <span className="text-sm font-semibold text-slate-900 leading-none">SelleSend</span>
        <span className="text-[10px] uppercase tracking-wider text-slate-500 font-mono hidden sm:inline">SelleSend.com</span>
        <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-slate-700" />
      </a>
    </div>
  );
}
